import { create } from "zustand";

import type { CommonModels } from "@/data/common/common.models";

interface IEndorsementModalProps {
  endorsement?: CommonModels.EndorsementDto | null;
  endorsementId?: string;
  type: "new" | "fill" | "fill-public" | undefined;
}

interface EndorsementModalsState {
  endorsement?: IEndorsementModalProps;
  setEndorsement: (endorsement: IEndorsementModalProps | undefined) => void;
}

export const useEndorsementModalsStore = create<EndorsementModalsState>((set) => ({
  // Initial state
  endorsement: undefined,
  // Actions
  setEndorsement: (endorsement) => set({ endorsement }),
}));
